import React from 'react';
import { Link } from 'react-router-dom';
import { createPath, ROUTE } from 'utils/Routing';
import './Header.css';

const Header = ({ isAuth }: { isAuth: boolean }) => {
  return (
    <div className='header__container'>
      <Link type='button' className='header__title' to={createPath({ path: ROUTE.HOME })}>
        Videogames nation
      </Link>
      <Link type='button' className='header__list' to={createPath({ path: ROUTE.GAME_LIST, params: { currentPage: 1 } })}>
        List of videogames
      </Link>
      <Link
        type='button'
        className='header__login action__button'
        to={createPath({ path: !isAuth ? ROUTE.LOGIN : ROUTE.LOGOUT })}
      >
        {!isAuth ? 'Login' : 'Logout'}
      </Link>
    </div>
  );
};

export default React.memo(Header);
